import Header from '@/components/Header'
import HeroBanner from '@/components/HeroBanner'
import WhyUnique from '@/components/WhyUnique'
import ProductGrid from '@/components/ProductGrid'
import PhotobookFeatures from '@/components/PhotobookFeatures'
import GallerySection from '@/components/GallerySection'
import TestimonialsSection from '@/components/TestimonialsSection'
import NewsletterSignup from '@/components/NewsletterSignup'
import Footer from '@/components/Footer'
import CTABanner from '@/components/CTABanner'
import WhatsAppCTABanner from '@/components/WhatsAppCTABanner'
import MetaTags from '@/components/MetaTags'
import SEOSchemaMarkup from '@/components/SEOSchemaMarkup'
import WhatsAppFab from '@/components/WhatsAppFab'

const Index = () => {
  return (
    <>
      <MetaTags
        title="FotoLivro Store — Suas Memórias Merecem ser Tocadas"
        description="Suas Memórias Merecem ser Tocadas"
        type="website"
        keywords="fotolivro, álbum de fotos personalizado, fotolivro casamento, fotolivro formatura, álbum fotográfico luxo, presente personalizado"
      />
      <SEOSchemaMarkup type="organization" />

      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1" role="main" aria-label="Conteúdo principal">
          <HeroBanner />

          <section aria-labelledby="why-unique-heading">
            <WhyUnique />
          </section>

          <section id="produtos" aria-labelledby="products-heading">
            <ProductGrid />
          </section>

          <section aria-labelledby="features-heading">
            <PhotobookFeatures />
          </section>

          <section aria-labelledby="gallery-heading">
            <GallerySection />
          </section>

          <aside
            className="container mx-auto px-4"
            aria-label="Chamada para ação"
          >
            <CTABanner
              title="Pronto para transformar suas memórias em um álbum exclusivo?"
              description="Cuidamos de cada detalhe, com um design pensado para valorizar a sua história."
              buttonText="Iniciar meu álbum"
              buttonLink="#produtos"
            />
          </aside>

          <section aria-labelledby="testimonials-heading">
            <TestimonialsSection />
          </section>

          <aside
            className="container mx-auto px-4"
            aria-label="Contato via WhatsApp"
          >
            <WhatsAppCTABanner />
          </aside>

          <section aria-labelledby="newsletter-heading">
            <NewsletterSignup />
          </section>
          <WhatsAppFab
            phone="554137950568"
            side="left"
            className="z-[+55 41 3795-0568]"
            message="Olá! Gostaria de mais informações sobre os fotolivros."
          />
        </main>
        <Footer />
      </div>
    </>
  )
}

export default Index
